
/**
 * Cache to register shared holidays
 * @kind cache
 * @class HolidaysLookup
 * @description Custom lookup cache for Holidays
 * @usage let lookup = await Grape.cache.get('HolidaysLookup');
 */
export default {
	name: 'HolidaysLookup',
	options: {
		refresh: async function (cb) {
			try
			{
				let res = await Grape.fetches.postJSON('/leave/get_holidays', {});
				if (res != null)
				{
					cb(null, res.data || []);
				}
			}
			catch (e)
			{
				cb(e, null);
			}
		}
	}
	// options: {
	// 	tablename: 'v_lookup_value',
	// 	schema: 'grape',
	// 	sortfield: 'idx',
	// 	filter: [{ field: 'lookup_name', operand: '=', value: 'PersonTitleLookup' }]
	// }
};
